// Generated sandbox code: SSVMN - PlusTools - Editor v - 11/10/2019
// Created/Updated by Developer - 10/23/2020

import { Component } from '@angular/core'
import { BaseController } from './base.controller';
import { PlusAlertsService} from 'components';


@Component({
  selector: 'ac-vi00',
  template: `<div [id]="getId()" #target><div>`,
  styleUrls: ['../styles/ac-vi00.component.css']
})

export class AcVi00 extends BaseController {

  constructor(plusAlertService: PlusAlertsService) {
    super();
    super.setViewCode('AC_VI00');
  }

  /* ---------------------- CONTROLLER LOGIC ------------------- */

  showCodeMsg(): void {
    this.plusAlertService.setCtDialogInfo('Confirmación de cambio', 'confirmation', 'inspect', 'primary', 'Estimado(a) asociado(a), enviamos un código de verificación a su medio de contacto favorito del tipo seleccionado para completar su solicitud de cambio de contraseña.', true, 'Aceptar', 'Regresar');

  }

  showUpdMsg(): void {

    this.plusAlertService.setCtDialogInfo('Operación completada', 'success','success', 'primary', 'Estimado(a) asociado(a), su contraseña ha sido cambiada exitosamente.', true, 'Aceptar', 'Cancelar');
  }

  /* -------------------- END CONTROLLER LOGIC ----------------- */

}
